/**
 * Admin V3 — i18n helper (French primary, Russian-ready)
 *
 * Same shape as components/adminv2/i18n.js (proven through M1/M2A/M2B).
 * t(key, locale) returns the label; falls back to French if a Russian key
 * is missing; returns the key itself as a last resort.
 */

import fr from './fr';
import ru from './ru';

export const DEFAULT_LOCALE = 'fr';
export const SUPPORTED_LOCALES = ['fr', 'ru'];

export const LABELS = { fr, ru };

export const t = (key, locale = DEFAULT_LOCALE) =>
  LABELS[locale]?.[key] ?? LABELS[DEFAULT_LOCALE]?.[key] ?? key;
